import { Address, UseCaseValue } from '@/types/Address';
import { create } from 'zustand';
import {
  AddressPerimetersResponse,
  BuildingDetails,
  BuildingHeatingResponse,
  DecisionTreeResponse,
  DistrictHeatingResponse,
  ParcelBuildingResponse,
  ParcelDetails,
  PriceCalculationResponse
} from '@/types/ApiTypes';

type State = {
  address: Address | null;
  decisionTree: DecisionTreeResponse | null;
  decisionTreeIsLoading: boolean;
  districtHeating: DistrictHeatingResponse | null;
  parcelBuilding: ParcelBuildingResponse | null;
  buildingHeating: BuildingHeatingResponse | null;
  addressPerimeters: AddressPerimetersResponse | null;
  buildingDetails: BuildingDetails | null;
  parcelDetails: ParcelDetails | null;
  priceCalculation: PriceCalculationResponse | null;
  isLoading: boolean;
  useCase: UseCaseValue | null;
};

type Action = {
  setAddress: (address: State['address']) => void;
  setDecisionTree: (decisionTree: State['decisionTree']) => void;
  setDecisionTreeIsLoading: (decisionTreeIsLoading: State['decisionTreeIsLoading']) => void;
  setDistrictHeating: (districtHeating: State['districtHeating']) => void;
  setParcelBuilding: (parcelBuilding: State['parcelBuilding']) => void;
  setBuildingHeating: (buildingHeating: State['buildingHeating']) => void;
  setAddressPerimeters: (addressPerimeters: State['addressPerimeters']) => void;
  setBuildingDetails: (buildingDetails: State['buildingDetails']) => void;
  setParcelDetails: (parcelDetails: State['parcelDetails']) => void;
  setPriceCalculation: (priceCalculation: State['priceCalculation']) => void;
  resetAddressStore: () => void;
  setIsLoading: (isLoading: State['isLoading']) => void;
  setUseCase: (useCase: State['useCase']) => void;
};

const initialState: State = {
  address: null,
  decisionTree: null,
  decisionTreeIsLoading: true,
  districtHeating: null,
  parcelBuilding: null,
  buildingHeating: null,
  addressPerimeters: null,
  buildingDetails: null,
  parcelDetails: null,
  priceCalculation: null,
  isLoading: true,
  useCase: null
};

export const useAddressStore = create<State & Action>((set) => ({
  ...initialState,
  setAddress: (address) => set({ address }),
  setDecisionTree: (decisionTree) => set({ decisionTree }),
  setDecisionTreeIsLoading: (decisionTreeIsLoading) => set({ decisionTreeIsLoading }),
  setDistrictHeating: (districtHeating) => set({ districtHeating }),
  setParcelBuilding: (parcelBuilding) => set({ parcelBuilding }),
  setBuildingHeating: (buildingHeating) => set({ buildingHeating }),
  setAddressPerimeters: (addressPerimeters) => set({ addressPerimeters }),
  setBuildingDetails: (buildingDetails) => set({ buildingDetails }),
  setParcelDetails: (parcelDetails) => set({ parcelDetails }),
  setPriceCalculation: (priceCalculation) => set({ priceCalculation }),
  resetAddressStore: () => set(initialState),
  setIsLoading: (isLoading) => set({ isLoading }),
  setUseCase: (useCase) => set({ useCase })
}));
